var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerPrice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 15a2 2 0 110 4 2 2 0 010-4zm0 1.5a.5.5 0 100 1 .5.5 0 000-1z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.459 8.47a.254.254 0 01.379.022l1.674 2.133c.094.12.27.13.379.023l.968-.968c.151-.15.409-.06.432.151l.56 5.113a.254.254 0 01-.073.206l-.053.054a.254.254 0 01-.382-.026l-1.395-1.843a.254.254 0 00-.382-.026l-.757.758a.254.254 0 01-.43-.13l-1.037-5.19a.255.255 0 01.07-.23l.047-.047z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.293 2.707a1 1 0 011.414 0l8.586 8.586a1 1 0 010 1.414l-9 9-.073.067a1 1 0 01-.535.221l-.1.005H3a1 1 0 01-1-1v-8.586a1 1 0 01.293-.707l9-9zM3.5 12.621v7.88h7.879l8.5-8.5L12 4.12l-8.5 8.5z",
    fill: "currentColor"
  })));
}
SvgPowerPrice.displayName = 'PowerPrice';
export default SvgPowerPrice;